import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { useDecisionMakerResponseMedia } from './hooks/useDecisionMakerResponseMedia';

export function DecisionMakerResponseMedia() {
	const {
		data: { photo },
	} = useDecisionMakerResponseMedia();

	if (photo) {
		return (
			<Box>
				<Image
					src={[photo.mobileUrl, photo.url]}
					fetchPriority="high"
					aspectRatio="16/9"
					fit="contain"
					alt=""
					sx={{
						width: ['100%', 600],
						borderRadius: 'standard',
						// removes an unwanted padding under the image
						verticalAlign: 'top',
					}}
					data-qa="dm-response-photo"
				/>
			</Box>
		);
	}

	return null;
}
